import { Component, OnInit } from '@angular/core';
import { PortalConfigService } from 'src/app/portal-config/shared/portal-config.service';
import { PortalConfig, ResourcesType } from 'src/app/portal-config/shared/portal-config.model';
import { StateService } from 'src/app/core/state-manager/appstateservice';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-oktaconfig-home',
  templateUrl: './oktaconfig-home.component.html',
  styleUrls: ['./oktaconfig-home.component.scss']
})
export class OktaconfigHomeComponent implements OnInit {
  bannerConfig: PortalConfig;
  resourcesType = ResourcesType;
  title = 'AECF Portals Okta Settings Configuration';
  bgImage = '/assets/images/HomePageImg.jpg';
  portalbannerConfig:boolean=false;
  constructor(private portalService: PortalConfigService, private currentState: StateService,private titleService: Title ) { }

  ngOnInit() {
    this.titleService.setTitle(environment.portalConfigPageTitle);
  }

  ischeckPermissions(permission: string): boolean {  return this.currentState.permissionCheck(permission); }
}
